module.exports = __webpack_public_path__ + "img/45.44e70ff5.png";